<template>
  <div>
    <!-- <v-card style="padding:20px"> -->
    <v-tabs v-model="tab">
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1"> Etsy Configuration </v-tab>

      <v-tab href="#tab-2"> Order Configuration </v-tab>

      <v-tab href="#tab-3"> General Settings </v-tab>

      <v-tab href="#tab-4"> Shipping Templates </v-tab>

      <v-tab href="#tab-5"> Processing Profiles </v-tab>

      <v-tab href="#tab-6"> Production Partners </v-tab>

      <v-tab href="#tab-7"> Return Policies </v-tab>

      <v-tab href="#tab-8"> Locations </v-tab>

      <v-tab href="#tab-9"> Etsy Configuration Options </v-tab>

<!--      <v-tab href="#tab-9"> Currency </v-tab>-->
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :key="1" value="tab-1">
        <etsy-configuration></etsy-configuration>
      </v-tab-item>

      <v-tab-item :key="2" value="tab-2">
        <order-configuration></order-configuration>
      </v-tab-item>

      <v-tab-item :key="3" value="tab-3">
        <general-settings></general-settings>
      </v-tab-item>

      <v-tab-item :key="4" value="tab-4">
        <shipping-templates></shipping-templates>
      </v-tab-item>

      <v-tab-item :key="5" value="tab-5">
        <processing-profiles></processing-profiles>
      </v-tab-item>

      <v-tab-item :key="6" value="tab-6">
        <production-partners></production-partners>
      </v-tab-item>

      <v-tab-item :key="7" value="tab-7">
        <return-policies></return-policies>
      </v-tab-item>

      <v-tab-item :key="8" value="tab-8">
        <locations></locations>
      </v-tab-item>

      <v-tab-item :key="9" value="tab-9">
        <etsy-configuration-options></etsy-configuration-options>
      </v-tab-item>

      <!--      <v-tab-item :key="9" value="tab-9">-->
      <!--        <currency></currency>-->
      <!--      </v-tab-item>-->
      <!--
        <v-tab-item>
          <v-card>
            <h1>HELLO</h1>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <h1>HELLO</h1>
          </v-card>
        </v-tab-item> -->
      <!-- <v-tab-item v-for="i in 3" :key="i" :value="'tab-' + i">
          <v-card flat>
            <v-card-text>{{ text }}</v-card-text>
          </v-card>
        </v-tab-item> -->
    </v-tabs-items>
    <!-- </v-card> -->
  </div>
</template>

<script>
import ShippingTemplates from './ShippingTemplates.vue'
import EtsyConfiguration from './EtsyConfiguration.vue'
import OrderConfiguration from './OrderConfiguration.vue'
import GeneralSettings from './GeneralSettings.vue'
import ProcessingProfiles from './ProcessingProfiles.vue'
import ProductionPartners from './ProductionPartners.vue'
import ReturnPolicies from './ReturnPolicies.vue'
import Locations from './Locations.vue'
import Currency from './Currency.vue'
import EtsyConfigurationOptions from './EtsyConfigurationOptions.vue'
export default {
  components: {
    ShippingTemplates,
    EtsyConfiguration,
    OrderConfiguration,
    GeneralSettings,
    ProcessingProfiles,
    ProductionPartners,
    ReturnPolicies,
    Locations,
    Currency,
    EtsyConfigurationOptions,
  },
  data() {
    return {
      tab: null,
      text: 'asdfasf',
    }
  },
}
</script>
